import { assert } from "@/common/assert";
import { fromNow } from "@/common/dateUtils";

var ChatMessageDto =
/** @class */
function () {
  function ChatMessageDto(messageId, ioType, deviceType, messageType, timestamp) {
    assert(messageId, "messageId is falsy");
    assert(ioType, "ioType is falsy");
    assert(typeof deviceType === "number", "deviceType is not number");
    assert(messageType, "messageType is falsy");
    this.id = messageId;
    this.MessageIOType = ioType;
    this.timestamp = timestamp;
    this.isTimestampShown = false;
    this.deviceType = deviceType;
    this.messageType = messageType;
    this.timestampText = this.getFriendlyTimestamp(timestamp);
    this.failed = false;
  }

  ChatMessageDto.prototype.getFriendlyTimestamp = function (timeStamp) {
    return fromNow(timeStamp);
  };

  ChatMessageDto.nextPendingMessageId = function () {
    var prefix = "pending:";
    var i = 0;
    return function () {
      i++;
      return "" + prefix + i;
    };
  }();

  return ChatMessageDto;
}();

export default ChatMessageDto;